import React from "react";
import {
  IDefaultProfilesMap,
  IFormFieldSubmission,
  ISubmissionFormDataServer,
  IUniversalStorageData,
} from "@common/redux/formSubmission/interface";
import { Config } from "@config/index";
import { PricingTypeEnum } from "@erelego/design-system/components/molecules/pricing/pricing";
import { IProfileData } from "@common/redux/profile/interface";
import { IFieldSubmissionMap } from "@erelego/design-system/interface/Forms/formSubmissionInterface";
import { IOrganizationDetails } from "@common/redux/admin/interface";

export enum FormMode {
  view = "view",
  edit = "edit",
  create = "create",
  payment = "payment",
  pricingSuccess = "pricingSuccess",
  pricingFailure = "pricingFailure",
  subscriptionVerify = "subscriptionVerify",
  pricingPage = "pricingPage",
  responseView = "RESPONSEVIEW",
}
export enum ProductName {
  forms = "FORMS",
  tenax = "TENAX",
  qrcode = "QR",
  shorturl = "URL",
  calendify = "CALENDAR",
}
export interface IFormProps {
  mode: FormMode;
  formId: string;
  submissionId: string;
  accessToken: string;
  apiUrl?: string;
  OrganisationName: string;
  config?: Config;
  formSubmitButtonText?: string;
  pricingType?: PricingTypeEnum;
  productSubscriptionMap?: ProductName;
  showPricingModule?: boolean;
  onSubmitSuccess?: (
    formSubmissionData: ISubmissionFormDataServer,
    fieldsMap?: any,
    fileData?: any
  ) => void;
  onSubmitFailure?: (error: string) => void;
  hideFormSubmissionSuccess?: boolean;
  showSaveFormConfirmationModal?: boolean;
  onCancelFormSubmission?: () => void;
  defaultFormFieldSubmissions?: IFormFieldSubmission[];
  defaultUniversalStorageData?: IUniversalStorageData;
  defaultProfilesMap?: IDefaultProfilesMap;
  isSubmissionRequired?: boolean;
  formCancelButton?: React.ReactElement;
  onCancelUpgrade?: () => void;
  isFormBuilderAsComponent?: boolean;
  ProfileData?: IProfileData;
  historyProps?: any;
  routeParamsProps?: any;
  accountIdProps?: string;
  activeProductName?: ProductName;
  planName?: string;
  backToApplication?: () => void;
  isFormResponseViewMode?: boolean;
  onCloseResponseScreenAction?: () => void;
  setFormsubmission?: React.Dispatch<React.SetStateAction<IFieldSubmissionMap>>;
  multiFormVertical?:boolean;
  organizationDetails?: IOrganizationDetails
  subscriptionId?: string;
  roleName?: string; 
}
